import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './LandingSection.module.scss';

const LandingSection = ({
  className = '',
  children,
  containerClassName = ''
}) => (
  <section className={classNames(styles['landing-section'], className)}>
    <div
      className={classNames(
        styles['landing-section__container'],
        containerClassName
      )}
    >
      {children}
    </div>
  </section>
);

LandingSection.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  containerClassName: PropTypes.string
};

export default LandingSection;
